var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "14",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d:
            "M13.916 1.287a1.188 1.188 0 0 1 1.705-.05c.448.431.501 1.13.147 1.625l-.097.12-9.279 10.226L.24 6.649a1.253 1.253 0 0 1 .247-1.727 1.187 1.187 0 0 1 1.59.134l.098.118 4.218 4.374 7.524-8.26Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }